import * as z from "zod";

/** `missing` narrows to variants short a field the team's return destinations
 * require; `returned` is every recently-returned variant, filled or not. */
export const InternationalCustomsExportScope = z.enum(["missing", "returned"]);
export type InternationalCustomsExportScope = z.infer<
  typeof InternationalCustomsExportScope
>;

export const exportInternationalCustomsCsv = {
  name: "exportInternationalCustomsCsv" as const,
  input: z.object({
    scope: InternationalCustomsExportScope,
    /** Unsaved toggle state from the settings form, so a previewed opt-out
     * exports the products it hands back before the merchant saves. */
    redoAssistedCustoms: z
      .object({
        hsCodeOptOut: z.boolean(),
        customsDescriptionOptOut: z.boolean(),
      })
      .optional(),
  }),
  output: z.object({
    /** Short-lived signed URL for the generated file. */
    url: z.string(),
    rowCount: z.number().int().nonnegative(),
    /** More rows remain; the file holds the first rowCount of them. */
    truncated: z.boolean(),
  }),
};
